/* ============================================
   LUMIÈRE JEWELRY THEME — theme.js
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Cart Drawer ── */
  const overlay = document.getElementById('cart-drawer-overlay');
  const drawer = document.getElementById('cart-drawer');
  const openBtns = document.querySelectorAll('[data-open-cart]');
  const closeBtn = document.getElementById('cart-drawer-close');

  function openCart() {
    overlay && overlay.classList.add('open');
    drawer && drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    overlay && overlay.classList.remove('open');
    drawer && drawer.classList.remove('open');
    document.body.style.overflow = '';
  }
  openBtns.forEach(b => b.addEventListener('click', openCart));
  closeBtn && closeBtn.addEventListener('click', closeCart);
  overlay && overlay.addEventListener('click', closeCart);

  /* ── Product Gallery Thumbnails ── */
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImg = document.querySelector('.gallery-main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if (mainImg) mainImg.src = this.querySelector('img').src;
    });
  });

  /* ── Quantity Selector ── */
  document.querySelectorAll('.quantity-selector').forEach(function (sel) {
    const input = sel.querySelector('.qty-input');
    sel.querySelector('.qty-minus') && sel.querySelector('.qty-minus').addEventListener('click', function () {
      if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    });
    sel.querySelector('.qty-plus') && sel.querySelector('.qty-plus').addEventListener('click', function () {
      if (input) input.value = parseInt(input.value) + 1;
    });
  });

  /* ── Variant Buttons ── */
  document.querySelectorAll('.variant-options').forEach(function (group) {
    group.querySelectorAll('.variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.classList.contains('sold-out')) return;
        group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
      });
    });
  });

  /* ── Add to Cart (AJAX) ── */
  const addToCartForm = document.getElementById('add-to-cart-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn = this.querySelector('.add-to-cart-btn');
      const variantId = this.querySelector('[name="id"]') ? this.querySelector('[name="id"]').value : null;
      const qty = this.querySelector('.qty-input') ? parseInt(this.querySelector('.qty-input').value) : 1;
      if (!variantId) return;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });
        if (res.ok) {
          btn.textContent = 'Added ✓';
          updateCartCount();
          setTimeout(() => { btn.textContent = 'Add to Cart'; btn.disabled = false; openCart(); }, 800);
        }
      } catch (err) {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }
    });
  }

  /* ── Update cart count badge ── */
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (e) {}
  }
  updateCartCount();

  /* ── Newsletter form ── */
  const nlForm = document.getElementById('newsletter-form');
  if (nlForm) {
    nlForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = this.querySelector('.newsletter-input');
      const btn = this.querySelector('.newsletter-btn');
      btn.textContent = 'Subscribed ✓';
      input.value = '';
      setTimeout(() => { btn.textContent = 'Subscribe'; }, 3000);
    });
  }

  /* ── Scroll fade-up animations ── */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.product-card, .testimonial-card, .category-card').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });
  }

});
